import type { SupportCategory, SupportStatus } from '../../api';

export const SUPPORT_CATEGORIES: { value: SupportCategory; label: string }[] = [
  { value: 'access', label: 'Вход и доступ' },
  { value: 'flights', label: 'Полёты и моточасы' },
  { value: 'maintenance', label: 'ТО и неисправности' },
  { value: 'finance', label: 'Финансы' },
  { value: 'bookings', label: 'Бронирование' },
  { value: 'other', label: 'Другое' },
];

export const categoryLabel = (value: SupportCategory) =>
  SUPPORT_CATEGORIES.find((item) => item.value === value)?.label ?? value;

export const SUPPORT_STATUS_LABELS: Record<SupportStatus, string> = {
  open: 'Ждёт ответа',
  answered: 'Есть ответ',
  resolved: 'Решено',
};

export const SUBJECT_MAX = 120;
export const BODY_MAX = 4000;
export const RATING_MAX = 5;

export const ratingLabel = (rating: number) => `${rating} из ${RATING_MAX}`;

const SCREEN_LABELS: [string, string][] = [
  ['/flights', 'Добавление полёта'],
  ['/stats', 'Статистика'],
  ['/bookings', 'Брони'],
  ['/issues', 'Неисправности'],
  ['/maintenance', 'ТО'],
  ['/condition', 'Техническое состояние'],
  ['/modernization', 'Модернизация'],
  ['/finance', 'Финансы'],
  ['/aircraft', 'Самолёт'],
  ['/club', 'Клуб'],
  ['/profile', 'Личный кабинет'],
];

/** Название экрана, с которого открыта поддержка: уходит в обращение как контекст. */
export const screenLabel = (path: string | undefined | null) => {
  if (!path || path === '/') return 'Главная';
  const match = SCREEN_LABELS.find(
    ([prefix]) => path === prefix || path.startsWith(`${prefix}/`)
  );
  return match ? match[1] : path.slice(0, 80);
};

const dateTimeFormat = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export const formatSupportDate = (iso: string) => dateTimeFormat.format(new Date(iso));
